import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "components/bootstrap";
import { Col, Row } from "components/lookup-tables/layout-componets";
import { usePurgeAllLookupTableKey, usePurgeLookupTableKey } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { Description } from "./lookup-table-show";
const INIT_INPUT = { value: "", valid: false };
function PurgeCache({ table }) {
  const { t } = useTranslation("lookup_tables");
  const [purgeKey, setPurgeKey] = useState(INIT_INPUT);
  const { purgeLookupTableKey } = usePurgeLookupTableKey();
  const { purgeAllLookupTableKey } = usePurgeAllLookupTableKey();
  const handlePurgeKey = (event) => {
    event.preventDefault();
    if (purgeKey.valid) {
      purgeLookupTableKey({ table, key: purgeKey.value }).then(() => {
        setPurgeKey(INIT_INPUT);
      });
    }
  };
  const onChange = (event) => {
    const newValue = { ...purgeKey };
    newValue.valid = event.target.value && event.target.value.replace(/\s/g, "").length > 0;
    newValue.value = event.target.value;
    setPurgeKey(newValue);
  };
  const hadlePurgeAll = (event) => {
    event.preventDefault();
    purgeAllLookupTableKey(table);
  };
  return /* @__PURE__ */ React.createElement(Col, { $gap: "sm" }, /* @__PURE__ */ React.createElement(Col, { $gap: "xs" }, /* @__PURE__ */ React.createElement("h2", null, t("lut_view.purge_title")), /* @__PURE__ */ React.createElement(Description, null, t("lut_view.purge_description"))), /* @__PURE__ */ React.createElement("form", { onSubmit: handlePurgeKey, style: { width: "100%" } }, /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "purge-key",
      name: "purgekey",
      placeholder: t("lut_view.purge_placeholder"),
      label: t("lut_view.key_label"),
      "data-testid": "purgekey",
      onChange,
      help: t("lut_view.purge_help"),
      required: true,
      value: purgeKey.value
    }
  ), /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { type: "submit", disabled: !purgeKey.valid }, t("lut_view.purge_key")), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", onClick: hadlePurgeAll }, t("lut_view.purge_all"))))));
}
export default PurgeCache;
